import React from 'react';
import { DeviceDetailPage } from '../../../../components/DeviceDetailPage';
import { useAppRoute } from '../../../../hooks/app-route-hooks';

export const OverviewSiteDeviceDetails: React.FC = () => {
    const currentAppRoute = useAppRoute('OverviewSiteDeviceDetails');

    return (
        <DeviceDetailPage
            testId="site-details-all-devices-device-details-page"
            appRoute={{
                type: 'OverviewSite',
                locationId: currentAppRoute.locationId,
                siteId: currentAppRoute.siteId,
            }}
        />
    );
};
